export const SUBSTRUCTURE_DATA = {
  brkey: null,
  inspectionId: null,
  subRating: null,
  subRatingDuration: null,
  subRatingDurationChanges: null,
  structureUnits: [],
  inspectionsUnderwater: [],
  inspectionFCs: [],
  inspectionComments: [],
  structureUnitInspComments: [],
};
